import en from "./dictionaries/en";
import hi from "./dictionaries/hi";
import mr from "./dictionaries/mr";
import gu from "./dictionaries/gu";
import ta from "./dictionaries/ta";
import te from "./dictionaries/te";
import kn from "./dictionaries/kn";
import bn from "./dictionaries/bn";
import pa from "./dictionaries/pa";
import ml from "./dictionaries/ml";

export const DICTIONARIES = { en, hi, mr, gu, ta, te, kn, bn, pa, ml };

/** Dot-path lookup (e.g. "tickets.cancelRequest") with graceful fallback:
 * current language -> English -> the raw key itself, so a page never shows
 * blank text just because one language's dictionary hasn't reached that key
 * yet — translation coverage can grow incrementally without ever breaking. */
export function translate(lang, key) {
  const dig = (dict) => key.split(".").reduce((o, k) => (o && typeof o === "object" ? o[k] : undefined), dict);
  return dig(DICTIONARIES[lang]) ?? dig(DICTIONARIES.en) ?? key;
}

export { APP_LANGS } from "./languages";
